var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "File Photo",
    d: "M6.16667 5.00016H9.83333L6.16667 1.3335V5.00016ZM1.5 0.333496H6.83333L10.8333 4.3335V12.3335C10.8333 12.6871 10.6929 13.0263 10.4428 13.2763C10.1928 13.5264 9.85362 13.6668 9.5 13.6668H1.5C0.760001 13.6668 0.166668 13.0668 0.166668 12.3335V1.66683C0.166668 0.926829 0.760001 0.333496 1.5 0.333496ZM1.5 12.3335H7.5H9.5V7.00016L6.83333 9.66683L5.5 8.3335L1.5 12.3335ZM2.83333 5.00016C2.47971 5.00016 2.14057 5.14064 1.89053 5.39069C1.64048 5.64074 1.5 5.97987 1.5 6.3335C1.5 6.68712 1.64048 7.02626 1.89053 7.2763C2.14057 7.52635 2.47971 7.66683 2.83333 7.66683C3.18696 7.66683 3.52609 7.52635 3.77614 7.2763C4.02619 7.02626 4.16667 6.68712 4.16667 6.3335C4.16667 5.97987 4.02619 5.64074 3.77614 5.39069C3.52609 5.14064 3.18696 5.00016 2.83333 5.00016Z",
    fill: "#344563"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhoto);
export default __webpack_public_path__ + "static/media/upload_photo.835a3eec31c4c65d5ce15da6556cd1b6.svg";
export { ForwardRef as ReactComponent };